<template>
  <button
    v-if="hasOtherComponentOptions || isClickableThemeSummary"
    class="customization-group group mb-1 w-full"
    :qaid="`customization-group-${option.description}`"
    @click="handleCustomizationGroupClick"
  >
    <div class="flex justify-between items-center">
      <div class="text-sm font-bold group-hover:text-blue group-hover:underline" qaid="customization-group-name">
        {{ option.description }}
      </div>
      <pdl-icon
        class="shrink-0 group-hover:text-blue group-focus:text-blue"
        qaid="customization-group-arrow"
        aria-hidden="true"
        name="arrow_forward"
      />
    </div>
    <current-selection
      :component-name="currentSelection.displayName"
      :price="priceDisplayed"
      :is-custom-component-selection="true"
    />
  </button>
  <div v-else :qaid="`customization-group-${option.description}`" class="mb-1">
    <div class="flex items-center">
      <div class="text-sm font-bold" qaid="customization-group-name">{{ option.description }}</div>
    </div>
    <current-selection
      :component-name="currentSelection.displayName"
      :price="priceDisplayed"
      :is-custom-component-selection="true"
    />
  </div>
</template>

<script>
import {PdlIcon} from '@pedal/pdl-icon';
import {mapGetters, mapState} from 'vuex';
import CurrentSelection from '@/components/containers/buy-zone/CurrentSelection.vue';
import {GROUP_IDS} from '@/familyDetailsPage/store/bike-customization';

const GROUPS = Object.freeze({
  COMPONENTS: 'components',
  COLOR: 'color',
});

export default {
  components: {
    PdlIcon,
    CurrentSelection,
  },
  props: {
    option: {
      type: Object,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
    theme: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('bikeCustomization', ['bikeData']),
    ...mapGetters('bikeCustomization', ['selections', 'selectedInspiration']),

    hasOtherComponentOptions() {
      return this.option.choices.length > 1 && this.group === GROUPS.COMPONENTS;
    },
    currentSelection() {
      let currentlySelected = {displayName: '', price: ''};

      const currentSelectionId = this.selections.find((selection) => selection.groupId === this.option.id)?.choiceId;
      const currentChoice = this.option.choices.find((choice) => choice.id === currentSelectionId);

      currentlySelected.displayName = currentChoice?.description;
      currentlySelected.price = currentChoice?.priceDifferenceAdvertised;

      return currentlySelected;
    },
    isClickableThemeSummary() {
      return (
        this.group === GROUPS.COLOR &&
        this.option.id === GROUP_IDS.THEME &&
        this.theme?.marketingThemeGroup &&
        this.theme.marketingThemeGroup !== 'Select'
      );
    },
    priceDisplayed() {
      if (this.group === GROUPS.COMPONENTS) {
        return this.currentSelection.price;
      } else if (this.option.id === GROUP_IDS.THEME) {
        return this.selectedInspiration?.advertisedPrice;
      } else {
        return '';
      }
    },
  },
  methods: {
    handleCustomizationGroupClick() {
      if (this.group === GROUPS.COMPONENTS) {
        this.$emit('custom-component-selector', this.option.description);
      } else if (this.isClickableThemeSummary) {
        this.$emit('theme-summary-clicked');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.customization-group {
  &:focus-visible {
    outline: 0.125rem solid var(--blue-100);
    outline-offset: -0.125rem;
  }
}
</style>
